import Vue from "vue";
import Router from "vue-router";
import guid from "./middleware/guid";
import newSession from "./middleware/newSession";
import prefill from "./middleware/prefill";
import lang from "./middleware/lang";
import get from "./middleware/get";
import tempGet from "./middleware/tempGet";
import lead from "./middleware/lead";
import addContract from "./middleware/addContract";
import blockCustomers from "./middleware/blockCustomers";
import bouee from "./middleware/bouee";
import consent from "./middleware/consent";
import themed from "./middleware/themed";
import { i18n } from "@/locales/index.js";
import routes from './routes'

Vue.use(Router);

function load(view) {
  return () => import(`@/views/${view}.vue`);
}

const router = new Router({
  mode: "history",
  base: process.env.URL_BASE,
  routes: [
    {
      path: "/",
      redirect: `/${i18n.locale}/situation/personal-details`
    },
    {
      path: "/become/:locale(fr|nl)?/comeback",
      redirect: `/${i18n.locale}/comeback`
    },
    {
      name: 'NotFound',
      path: '*',
      component: load("NotFound")
    },
    {
      name: 'ServerError',
      path: '/error',
      component: load("ServerError")
    },
    {
      name: "Default",
      path: "/:locale(fr|nl)?",
      component: {
        template: "<router-view />"
      },
      children: routes
    },
    {
      path: "/:id(\\d+)/:guid",
      meta: {
        middleware: [guid, bouee]
      }
    },
    {
      path: "/get",
      // meta: {
      //   allow: true,
      // }
    },
    {
      path: "/lead/:lead",
      meta: {
        // allow: true,
        middleware: [lead]
      }
    },
    {
      path: "/add/:id(\\d+)/:guid",
      meta: {
        middleware: [addContract]
      }
    },
    {
      path: "/confirm/:id(\\d+)/:guid/:confirm",
      meta: {
        middleware: [guid, consent]
      },
    },
    {
      path: "/prefill",
      meta: {
        middleware: [prefill]
      }
    }
  ]
});

const nextFactory = (context, middleware, index) => {
  const subsequentMiddleware = middleware[index];
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters);
    // Than run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
};

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);

  let middleware = [lang];

  if (Object.keys(to.query).length) {
    middleware.push(newSession);
    middleware.push(get);
    middleware.push(tempGet);
    middleware.push(themed)
  }

  if (to.meta.middleware) {
    middleware.push(...to.meta.middleware);
  }

  if(process.env.BLOCK_CUSTOMERS) {
    middleware.push(blockCustomers);
  }

  if (middleware.length) {
    const context = { from, next, router, to };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

/* Vue Router is not meant to handle absolute urls. */
/* So whenever we want to deal with those, we can use this.$router.absUrl(url) */
Router.prototype.absoluteUrl = function(url, newTab = true) {
  const link = document.createElement('a')
  link.href = url
  link.target = newTab ? '_blank' : ''
  if (newTab) link.rel = 'noopener noreferrer' // IMPORTANT to add this
  link.click()
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js